import React from 'react'
import {
    FaBolt,
    FaCalendarAlt,
    FaPlug,
    FaMapMarkedAlt,
} from 'react-icons/fa'

const features = [
    {
        title: 'On-Demand Delivery (ASAP)',
        icon: <FaBolt />,
        description:
            'Need something delivered urgently? Tuber’s on-demand network ensures your customers get their orders within 1–2 hours.',
    },
    {
        title: 'Scheduled & Bulk Deliveries',
        icon: <FaCalendarAlt />,
        description:
            'For high-volume businesses, our scheduled delivery slots help streamline operations, optimise logistics, and reduce costs.',
    },
    {
        title: 'Easy eCommerce & POS Integration',
        icon: <FaPlug />,
        description:
            'Our plug-and-play API lets you connect Tuber to your online store, making same-day delivery a seamless option at checkout.',
    },
    {
        title: 'Real-Time Order Tracking',
        icon: <FaMapMarkedAlt />,
        description:
            'Both you and your customers can track deliveries from pickup to drop-off with live updates and instant notifications.',
    },
]

const DeliverySolutions = () => {
    return (
        <section className="px-4 py-10 md:py-24">
            <div className="max-w-6xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold text-headings mb-12 max-w-[550px] w-full mx-auto text-center">
                    Powerful Delivery Solutions for Your Business
                </h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                    {features.map((feature, idx) => (
                        <div
                            key={idx}
                            className="bg-white shadow-shadow-2 p-4 md:p-8 flex items-center gap-5"
                        >
                            <div className='bg-primary w-12 md:w-14 h-12 md:h-14 rounded-full flex items-center justify-center text-white text-xl md:text-2xl'>
                                {feature.icon}
                            </div>

                            <div className='flex-1 space-y-1'>
                                <h3 className="text-base md:text-lg font-bold text-headings">
                                    {feature.title}
                                </h3>
                                <p className="text-sm text-light_black">{feature.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default DeliverySolutions
